<template>
  <ValidationObserver ref="observer" v-slot="{ invalid }">
    <tsny-modal
      :modal-id="modalId"
      :modal-title="'Create Exam'"
      :submit-button-text="'CREATE'"
      :submit-disabled="invalid"
      :reset-modal="resetModal"
      :submit-modal="createExam"
    >
      <b-row>
        <b-col>
          <b-text-input-validated
            label="Exam Name"
            v-model="examName"
            rules="required"
          />
        </b-col>
      </b-row>
      <b-row v-if="createExamError">
        <b-col>
          <p class="tsny_status-text">An error occurred creating your exam.</p>
        </b-col>
      </b-row>
    </tsny-modal>
  </ValidationObserver>
</template>

<script>
import TsnyModal from "../TsnyModal";
import { ValidationObserver } from "vee-validate";
import BTextInputValidated from "../FormInputs/BTextInputValidated";
import ExamRestService from "../../services/rest/services/ExamRestService";

export default {
  name: "CreateExamModal",
  components: {
    TsnyModal,
    ValidationObserver,
    BTextInputValidated
  },
  props: {
    courseId: {
      type: String,
      default: null
    }
  },
  computed: {},
  data() {
    return {
      modalId: "createExamModal",
      createExamError: false,
      examName: null
    };
  },
  methods: {
    resetModal() {
      this.createExamError = false;
      this.examName = null;
    },
    async createExam(bvModalEvent) {
      bvModalEvent.preventDefault();

      let $comp = this,
        isValid = await this.$refs.observer.validate();

      $comp.createExamError = false;

      if (!isValid) return;

      try {
        await ExamRestService.createExam({
          courseId: $comp.courseId,
          examName: $comp.examName
        });
        $comp.$bvModal.hide($comp.modalId);
      } catch (e) {
        console.log(e);
        $comp.createExamError = true;
      }
    }
  }
};
</script>

<style scoped></style>
